import {computeIsHeaderRow, RowIdentity} from 'notebook/tables/store/logic/TableIdentityLogic';
import {TableModel} from 'notebook/tables/store/models/TableModel';
import {createDebuggableSelector} from 'notebook/tables/store/selectors/util/SelectorCreators';
import {
  createTableEditableStoreStructuredSelector,
  TableEditableStore,
} from 'notebook/tables/store/TableStore';

/**
 * Creates a selector that computes per-row identity and render metadata
 * ({@link RowIdentity}) for a single row from the {@link TableModel}.
 */
export function createRowIdentitySelector(
  tableSelector: (store: TableEditableStore) => TableModel,
  rowIndex: number
): (store: TableEditableStore) => RowIdentity {
  return createTableEditableStoreStructuredSelector(
    {
      isHeaderRow: (store) => computeIsHeaderRow(rowIndex, tableSelector(store).props.table.headerRow),
    },
    createDebuggableSelector.withTypes<TableEditableStore>()
  );
}
